import {ActionCreatorDefinition, createAction} from "redux-ts";
import {ModalType} from "enum/ModalType";
import {Tooltip} from "core/redux/app/AppReduxState";
import {BooleanPayload} from "core/redux/StoreActions";
import {ActivityType} from "enum/ActivityType";

export const SetModalType: string =  "SetModal";
export const CloseMeType: string =  "CloseMe";
export const SetTooltipType: string = "SetTooltip";
export const SetCallMeType: string = "SetCallMe";
export const SetKycContextType: string = "SetKycContext";
export const SetBackNavigationType: string = "SetBackNavigation";
export const DoRegisterActivityType: string = "DoRegisterActivity";

export interface SetModalPayload {

    modalType: ModalType;
    visible: boolean;
}

export interface SetTooltipPayload {

    tooltip: Tooltip;
}

export interface DoRegisterActivityPayload {

    activity: ActivityType;
    comments?: string;
}

export const SetModal: ActionCreatorDefinition<SetModalPayload, any> = createAction<SetModalPayload>(SetModalType);
export const CloseMe: ActionCreatorDefinition<any, any> = createAction<any>(CloseMeType);
export const SetTooltip: ActionCreatorDefinition<SetTooltipPayload, any> = createAction<SetTooltipPayload>(SetTooltipType);
export const SetCallMe: ActionCreatorDefinition<BooleanPayload, any> = createAction<BooleanPayload>(SetCallMeType);
export const SetKycContext: ActionCreatorDefinition<BooleanPayload, any> = createAction<BooleanPayload>(SetKycContextType);
export const SetBackNavigation: ActionCreatorDefinition<BooleanPayload, any> = createAction<BooleanPayload>(SetBackNavigationType);
export const DoRegisterActivity: ActionCreatorDefinition<DoRegisterActivityPayload, any> = createAction<DoRegisterActivityPayload>(DoRegisterActivityType);
